/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

// libs
import { makeFichaAvisoURL } from '@navent-jobs/interlinking'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// components
import AdManager from '../ads'
import BannerFundacionTelefonica from '../../../../components/banner-fundacion-telefonica'
import ProductBanner from '../../../../components/product-banner'

// mixins
import { ListadoAvisoCard } from './mixins'

// store
import features from '../../../../constants/features-per-country'
import { IS_ZONA_JOBS, SITE_ID } from '../../../../constants'
import { CardDataLayers } from '../../../../constants/gtm-events-cards'
import AreaAd from '../../../../components/area-ad'
import { Aviso } from '../../../../redux/types/listado-avisos'

const CONFIDENCIAL = 'Confidencial'
const ZONAUTMCAMPAING = '?utm_source=zonajobs&utm_medium=free&utm_campaign=crossbrand'

// features
const productBannersFeature = features[SITE_ID || 'BMAR'].marketplace?.banners?.enabled
const googleAdsListEnabled = features[SITE_ID || 'BMAR'].googleAds?.list?.enabled
const { avisosFake = {} } = features[SITE_ID || 'BMAR']
const areaAdsFeature = features[SITE_ID || 'BMAR'].areaAds?.enabled

const generateUtm = isBumeranInZona => {
  return isBumeranInZona ? ZONAUTMCAMPAING : ''
}

const AvisoFake = ({ index }) => {
  const bannerAviso = avisosFake.banners[index]

  useEffect(() => {
    CardDataLayers.avisoFakeTracking('view', bannerAviso.titulo)
  }, [])

  return (
    <ListadoAvisoCard
      key={`aviso-fake-${index}`}
      aviso={{ ...bannerAviso, ...avisosFake.aviso }}
      onClick={() => window.open(avisosFake.url)}
      handleMetrics={() => CardDataLayers.avisoFakeTracking('click', bannerAviso.titulo)}
      disableLink
      disableSaveJobPosting
      hideCompanyRow
    />
  )
}

interface ListadoAvisosCard {
  filtersApplied: any
  isFirstPage: boolean
  activeAviso: any
  avisos: Aviso[]
  ads: any
  activeLanding: string
  onClickAvisoHandler: (event: React.MouseEvent, url: string, isBumeranInZona?: boolean) => void
}

const ListadoAvisosCard = ({
  filtersApplied,
  isFirstPage,
  activeAviso,
  avisos,
  ads,
  activeLanding,
  onClickAvisoHandler,
}) => {
  const landingJovenesProfesionales = activeLanding === 'jovenes-profesionales'
  const { isDesktop } = useWindowSize()

  const topPositionInList = 0
  const firstPositionInList = 1
  const secondPositionInList = 2
  const tenthPositionInList = 9

  const avisosFakeEnabled =
    avisosFake.enabled &&
    isFirstPage &&
    !filtersApplied?.find(f => ['area', 'subarea'].includes(f.type) || f.id === 'query')

  return (
    avisos &&
    avisos.map((aviso, index) => {
      const isBumeranInZona = IS_ZONA_JOBS && aviso.portal?.toLowerCase() === 'bumeran'
      const utm = generateUtm(isBumeranInZona)
      return (
        <>
          {index === topPositionInList && areaAdsFeature && (
            <AreaAd areaApplied={filtersApplied?.filter(f => f.type === 'area')[0]?.id} />
          )}
          {index === firstPositionInList && productBannersFeature && <ProductBanner colSizeXl={9} verticalSize="sm" />}
          {index === secondPositionInList && landingJovenesProfesionales && <BannerFundacionTelefonica />}

          {index === tenthPositionInList && ads && isDesktop && !productBannersFeature && googleAdsListEnabled && (
            <AdManager name="listado-google-list" />
          )}

          {avisosFakeEnabled && avisosFake.banners[index] && <AvisoFake index={index} />}

          <ListadoAvisoCard
            key={aviso.id}
            aviso={aviso}
            disableLink={false}
            index={index}
            ubicacion="Listado"
            activeAvisoId={activeAviso && activeAviso.activeAvisoId}
            onClick={({ event }) =>
              onClickAvisoHandler(
                event,
                makeFichaAvisoURL({
                  ...aviso,
                  empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
                }) + utm,
                isBumeranInZona
              )
            }
            link={
              makeFichaAvisoURL({
                ...aviso,
                empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
              }) + utm
            }
          />
        </>
      )
    })
  )
}

const states = ({ filtersStore }) => ({
  filtersApplied: filtersStore.filtersApplied,
})

export default connect(states)(ListadoAvisosCard)
